
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class SummaryTable extends Vue {
    @Prop({ required: true }) monthHeaders!: string[];
    @Prop({ required: true }) currentYear!: number;
    @Prop({ required: true }) previousYear!: number;
    @Prop({ required: true }) summaryRows!: any[];
    @Prop({ required: true }) loading!: boolean;

    get mainHeaders() {
        return [...this.monthHeaders, `Total ${this.currentYear}`, `Total ${this.previousYear}`];
    }

    get subHeadersFlat() {
        const arr: string[] = [];
        this.mainHeaders.forEach((header, index) => {
            if (index === this.mainHeaders.length - 1) {
                arr.push('Real');
            } else {
                arr.push('Real', 'Objetivo');
            }
        });
        return arr;
    }
}
